import {useMemo, useState} from 'react';
import {TTimetableItem} from '../../../redux/timetable/timetable.type';
import {localSearch} from '../../../library/searchFunctions';

export function useTimetableSearch(lectures: TTimetableItem[]) {
    const [searchQuery, setSearchQuery] = useState('');
    const visibleLectures = useMemo<TTimetableItem[]>(() => {
        const q = searchQuery.trim().toLowerCase();
        if(!q) return lectures;
        return lectures.filter(l => {
            const lecturerNames = (l.lecturers ?? [])
                .map(x => `${x.firstName} ${x.lastName}`)
                .join(' ');
            return localSearch(
                [{title: l.title, place: l.place, lecturerNames}],
                q,
                ['title', 'place', 'lecturerNames']
            ).length > 0;
        });
    }, [lectures, searchQuery]);
    return {searchQuery, setSearchQuery, visibleLectures};
}
